"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _elementUi = require("element-ui");

var _permission = require("@/mixins/permission/permission");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AdminZonesComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(AdminZonesComponent, _Mixins);

  var _super = _createSuper(AdminZonesComponent);

  function AdminZonesComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, AdminZonesComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.activeTab = 'checkZone';
    _this.selectedCustomer = {};
    _this.fromCopyCustomer = {};
    _this.toCopyCustomer = {};
    _this.fromProjectCode = {};
    _this.toProjectCode = {};
    _this.customers = [];
    _this.zones = [];
    _this.fromProjectCodes = [];
    _this.toProjectCodes = [];
    return _this;
  }

  (0, _createClass2.default)(AdminZonesComponent, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loading = false;

        _this2.getAllCustomer().then(function (customerData) {
          if (customerData && customerData.length >= 1) {
            _this2.customers = customerData.map(function (cData) {
              return {
                code: cData['code'] || '',
                company: cData['company'] || '',
                key: cData['key'] || '',
                id: cData['_id'] || ''
              };
            });
          }
        }).catch(function (e) {
          return _this2.logger.error(e);
        });
      });
    }
  }, {
    key: "getAllCustomer",
    value: function getAllCustomer() {
      var _this3 = this;

      return this.request.get('ROUTING', 'v1/auth/customers', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        limit: 999
      })).then(function (data) {
        if (!data['data']) {
          return Promise.reject('');
        }

        return data['data'] || [];
      }).catch(function (e) {
        _this3.logger.error(e);

        return null;
      });
    }
  }, {
    key: "loadSelectedZone",
    value: function loadSelectedZone() {
      var _this$request$get,
          _this4 = this;

      if (!this.selectedCustomer || !this.selectedCustomer['key']) {
        return;
      }

      this.request.get('ROUTING', 'v1/core/zones', (_this$request$get = {}, (0, _defineProperty2.default)(_this$request$get, process.env.VUE_APP_CUSTOMER_KEY, this.selectedCustomer['key']), (0, _defineProperty2.default)(_this$request$get, "limit", 999), _this$request$get)).then(function (data) {
        if (!data['data']) {
          return Promise.reject('');
        }

        _this4.zones = data['data'] || [];
      }).catch(function (e) {
        _this4.logger.error(e);

        _this4.zones = [];
      });
    }
  }, {
    key: "loadSelectedProjectCode",
    value: function loadSelectedProjectCode() {
      var _this5 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'from';

      if (!type) {
        return;
      }

      if (type === 'from') {
        var _this$request$get2;

        if (!this.fromCopyCustomer || !this.fromCopyCustomer['key']) {
          return;
        }

        this.request.get('ROUTING', 'v1/core/projectcodes', (_this$request$get2 = {}, (0, _defineProperty2.default)(_this$request$get2, process.env.VUE_APP_CUSTOMER_KEY, this.fromCopyCustomer['key']), (0, _defineProperty2.default)(_this$request$get2, "limit", 999), _this$request$get2)).then(function (data) {
          if (!data['data']) {
            return Promise.reject('');
          }

          _this5.fromProjectCodes = data['data'] || [];
        }).catch(function (e) {
          _this5.logger.error(e);

          _this5.fromProjectCodes = [];
        });
      } else {
        var _this$request$get3;

        if (!this.toCopyCustomer || !this.toCopyCustomer['key']) {
          return;
        }

        this.request.get('ROUTING', 'v1/core/projectcodes', (_this$request$get3 = {}, (0, _defineProperty2.default)(_this$request$get3, process.env.VUE_APP_CUSTOMER_KEY, this.toCopyCustomer['key']), (0, _defineProperty2.default)(_this$request$get3, "limit", 999), _this$request$get3)).then(function (data) {
          if (!data['data']) {
            return Promise.reject('');
          }

          _this5.toProjectCodes = data['data'] || [];
        }).catch(function (e) {
          _this5.logger.error(e);

          _this5.toProjectCodes = [];
        });
      }
    }
  }, {
    key: "copyDisable",
    get: function get() {
      return !(this.fromCopyCustomer['id'] && this.toCopyCustomer['id'] && this.fromProjectCode['ProjectCode'] && this.toProjectCode['ProjectCode']);
    }
  }, {
    key: "copyZones",
    value: function copyZones() {
      var _this6 = this;

      if (!this.fromCopyCustomer['id'] || !this.toCopyCustomer['id'] || !this.fromProjectCode['ProjectCode'] || !this.toProjectCode['ProjectCode']) {
        return;
      }

      this.request.post('ROUTING', 'v1/core/zone/customercopy', (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.toCopyCustomer['key']), {
        customerFrom: this.fromCopyCustomer['id'],
        customerTo: this.toCopyCustomer['id'],
        projectFrom: this.fromProjectCode['ProjectCode'],
        projectTo: this.toProjectCode['ProjectCode']
      }).then(function (data) {
        if (!data || data.status !== 'success') {
          return Promise.reject('');
        }

        var message = {
          title: _this6.$i18n.t('notification.zones.copySuccess'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }).catch(function (error) {
        var message = {
          title: _this6.helper.toString(error),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }]);
  return AdminZonesComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], AdminZonesComponent.prototype, "$userInformation", void 0);
AdminZonesComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'AdminZonesComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-input': _elementUi.Input,
    'el-tabs': _elementUi.Tabs,
    'el-tab-pane': _elementUi.TabPane
  }
})], AdminZonesComponent);
var _default = AdminZonesComponent;
exports.default = _default;